"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsWeb = require("@olxbr/ds-web");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Messages = function Messages() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SentWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
        width: "100%",
        height: "100%"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SameSpacer, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SentWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
        width: "100%",
        height: "100%"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.DifferentSpacer, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ReceivedWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
        width: "100%",
        height: "100%"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SameSpacer, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ReceivedWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
        width: "100%",
        height: "100%"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.DifferentSpacer, {})]
  });
};
var MessageBoxLoading = function MessageBoxLoading(_ref) {
  var isAdview = _ref.isAdview;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    isAdview: isAdview,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.MessagesWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Messages, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Messages, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Messages, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Messages, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Messages, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Messages, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Messages, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Messages, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ActionButtonsWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Line, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Buttons, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.FakeButton, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
            width: "100%",
            height: "100%"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.FakeButton, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
            width: "100%",
            height: "100%"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.FakeButton, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
            width: "100%",
            height: "100%"
          })
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.InputWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.InputIconWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
          width: "100%",
          height: "100%"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.InputTextWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Skeleton, {
          width: "100%",
          height: "100%"
        })
      })]
    })]
  });
};
var _default = exports["default"] = MessageBoxLoading;